import * as XLSX from "xlsx";
import {
  ParetoAnalysisData,
  RFMSegmentationData,
  HighValueAtRiskData,
} from "../../models/customer-analytics/customer-analytics.model";

const formatDate = (dateString: string | null | undefined): string => {
  if (!dateString || dateString.startsWith("0001")) return "";
  const date = new Date(dateString);
  return isNaN(date.getTime()) ? "" : date.toLocaleDateString("en-GB");
};

export const exportParetoAnalysis = (data: ParetoAnalysisData[]) => {
  if (!data || data.length === 0) return;

  const rows = data.map((d) => ({
    "Customer Name": d.customerName,
    Contact: d.primaryContactNbr,
    "Total Orders": d.totalOrders,
    "Total Revenue": d.totalRevenue,
    "Avg Order Value": d.avgOrderValue,
    "First Order Date": formatDate(d.firstOrderDate),
    "Last Order Date": formatDate(d.lastOrderDate),
    "Days Since Last Order": d.daysSinceLastOrder,
    "Cumulative Revenue %": d.cumulativeRevenuePercent,
    Decile: d.decile,
  }));

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(rows);
  XLSX.utils.book_append_sheet(wb, ws, "Pareto Analysis");
  XLSX.writeFile(wb, "ParetoAnalysis.xlsx");
};

export const exportRFMSegmentation = (data: RFMSegmentationData[]) => {
  if (!data || data.length === 0) return;

  const rows = data.map((d) => ({
    "Customer Name": d.customerName,
    Contact: d.primaryContactNbr,
    Recency: d.recency,
    Frequency: d.frequency,
    Monetary: d.monetary,
    "Recency Score": d.recencyScore,
    "Frequency Score": d.frequencyScore,
    "Monetary Score": d.monetaryScore,
    "RFM Total": d.rfmTotal,
    Segment: d.customerSegment,
  }));

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(rows);
  XLSX.utils.book_append_sheet(wb, ws, "RFM Segmentation");
  XLSX.writeFile(wb, "RFMSegmentation.xlsx");
};

export const exportHighValueAtRisk = (data: HighValueAtRiskData[]) => {
  if (!data || data.length === 0) return;

  const rows = data.map((d) => ({
    "Customer Name": d.name,
    Contact: d.primaryContactNbr,
    "Total Orders": d.totalOrders,
    "Lifetime Revenue": d.lifetimeRevenue,
    "Avg Order Value": d.avgOrderValue,
    "Last Order Date": formatDate(d.lastOrderDate),
    "Days Since Last Order": d.daysSinceLastOrder,
  }));

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(rows);
  XLSX.utils.book_append_sheet(wb, ws, "High Value At Risk");
  XLSX.writeFile(wb, "HighValueAtRisk.xlsx");
};
